import { render } from "./index.vue?vue&type=template&id=65a09bec"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=65a09bec&lang=scss"
script.render = render

export default script